export default "__VITE_ASSET__wCltTX4i__"